import { SystemInfo, ConfigurationDetail } from "./types";

export function getDataFromSession<T>(key: string, defaultValue: T): T {
  const storedData = localStorage.getItem(key);
  return storedData ? JSON.parse(storedData) : defaultValue;
}

export function storeDataInSession(key: string, data: any) {
  localStorage.setItem(key, JSON.stringify(data));
}

export function normalizeSystemName(systemName: string): string {
  return systemName
    .toLowerCase()
    .replace(/\+/g, 'plus')
    .replace(/\./g, '')
    .replace(/\s+/g, '')
    .replace(/-/g, '')
    .replace(/_/g, '');
}

export function findPrice(
  configurationSort: ConfigurationDetail,
  supllier: string,
  system1: string
): number | undefined {
  const normalizedSystem1 = normalizeSystemName(system1);
  
  // Try exact match first
  let config = configurationSort?.filteredResult.find(
    (config) =>
      config.supllier === supllier &&
      config.system1 === system1
  );
  
  // If no exact match, try normalized match
  if (!config) {
    config = configurationSort?.filteredResult.find(
      (config) =>
        config.supllier === supllier &&
        normalizeSystemName(config.system1) === normalizedSystem1
    );
  }
  
  return config ? config.price : undefined;
}

export function findSystem(
  tableData: SystemInfo[],
  system1: string
): SystemInfo | undefined {
  const normalizedSystem1 = normalizeSystemName(system1);
  
  // Try exact match first
  let system = tableData.find((config) => config.system1 === system1);
  
  // If no exact match, try normalized match
  if (!system) {
    system = tableData.find((config) => 
      normalizeSystemName(config.system1) === normalizedSystem1
    );
  }
  
  return system;
}
